import axios from "axios";
import { acceptBidUrl } from "../../utils";

export const acceptBid = (bidId: string) => {
  return axios.patch(acceptBidUrl(bidId));
};
